var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconButton',{attrs:{"clickHandler":_vm.clickHandler,"height":_vm.height,"title":_vm.title,"disabled":_vm.disabled,"viewBox":"0 0 320 512","path":"M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }